export default __webpack_public_path__ + "static/media/h4_bg.cdf07b20.png";